import { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useCart } from '@kidslabs/module-quote';
import { checkoutStoreAPI } from '@kidslabs/module-checkout';
import { useMarketingApplyCode } from '../../../api';

// TODO-7.4: Map server error messages to user-friendly translated messages
const getErrorMessageKey = (serverMessage: string): string | undefined => {
    const errorMap: Record<string, string> = {
        'Code is not valid.': 'text_coupon_code_invalid',
        'Voucher is not available.': 'text_voucher_not_available',
        'Voucher has expired.': 'text_voucher_expired',
        'Voucher is not yet active.': 'text_voucher_not_active',
        'Quota exceeded': 'text_voucher_quota_exceeded',
    };

    for (const [key, value] of Object.entries(errorMap)) {
        if (serverMessage.includes(key)) {
            return value;
        }
    }
    return undefined;
};

export const useApplyCode = () => {
    const { cartId } = useCart();
    const { t } = useTranslation('flash-sale');
    const [errorMessage, setErrorMessage] = useState<string | undefined>();

    const { applyCode: applyCodeMutation, loading: applyLoading } = useMarketingApplyCode();

    const applyCode = useCallback(
        async (code: string) => {
            setErrorMessage(undefined);
            if (!cartId) {
                return;
            }
            const result = await applyCodeMutation({
                variables: { code, cart_id: cartId },
            });

            const response = result?.data?.marketingApplyCode;
            const message = response?.error_message;

            if (message) {
                // TODO-7.4: Try to map to user-friendly message
                const mappedKey = getErrorMessageKey(message);
                const friendlyMessage = mappedKey ? t(mappedKey) : message;
                setErrorMessage(friendlyMessage);
                throw new Error(friendlyMessage);
            }

            // Signal hooks watching discountVersion to refetch their data
            checkoutStoreAPI.actions.incrementDiscountVersion();
        },
        [applyCodeMutation, cartId, t]
    );

    return {
        applyCode,
        applyLoading,
        errorMessage,
        setErrorMessage,
    };
};
